/* eslint-disable prettier/prettier */
import { TranslationMap } from './default'

export const id: TranslationMap = {
  "accountstatus.Active": "Aktif",
  "accountstatus.Inactive": "Tidak aktif",
  "accountstatus.Terminated": "Dihentikan",
  "additionalitems.title": "Barang tambahan",
  "cart.addtocart": "Masukkan ke keranjang",
  "cart.addtocart.alreadyincart": "@@PRODUCT@@ sudah ada di keranjang Anda",
  "cart.addtocart.currencylocked": "Keranjang Anda saat ini disetel ke @@CURRENCY@@. Tidak mungkin menggabungkan beberapa mata uang dalam satu pesanan. Untuk membeli produk ini, harap hapus @@SHOPPING_CART@@ Anda terlebih dahulu.",
  "cart.addtocart.locked": "Mata uang keranjang Anda telah disetel ke @@CURRENCY@@ dengan lokasi kirim-ke berikut @@LOCATION@@",
  "cart.addtocart.shiptolocked": "Keranjang belanja Anda telah diatur ke lokasi pengiriman ke @@LOCATION@@ Untuk membeli produk ini, ubah lokasi pengiriman ke di @@SHOPPING_CART@@ terlebih dahulu",
  "cart.addtocart.success": "@@PRODUCT@@ telah ditambahkan ke keranjang Anda",
  "cart.empty": "Keranjang Anda saat ini kosong",
  "cart.empty.title": "Keranjang belanja anda kosong",
  "cart.gotoproductlist": "Buka daftar produk",
  "cart.nolongervalid": "Keranjang Anda tidak valid, perbarui untuk melanjutkan",
  "cart.recalculate": "Hitung ulang",
  "cart.recalculate.rounding": "Jumlah yang diminta dibulatkan agar sesuai dengan ukuran paket.",
  "cart.removefromcart.success": "@@PRODUCT@@ berhasil dihapus dari keranjang Anda",
  "cart.removeproduct": "Anda yakin ingin menghapus @@PRODUCT@@ dari keranjang belanja Anda?",
  "cart.requestquote": "Minta kutipan",
  "cart.updatecart": "Memperbarui",
  "cart.updatecart.success": "@@PRODUCT@@ telah diperbarui di keranjang Anda",
  "dangerousgoodsclass.1": "Mudah meledak (1)",
  "dangerousgoodsclass.2.1": "Gas yang mudah terbakar (2.1)",
  "dangerousgoodsclass.2.2": "Gas tidak mudah terbakar (2.2)",
  "dangerousgoodsclass.2.3": "Gas beracun (2.3)",
  "dangerousgoodsclass.3": "Cairan yang mudah terbakar (3)",
  "dangerousgoodsclass.4.1": "Padatan yang mudah terbakar (4.1)",
  "dangerousgoodsclass.4.2": "Padatan yang mudah terbakar mudah terbakar (4.2)",
  "dangerousgoodsclass.4.3": "Berbahaya saat basah (4.3)",
  "dangerousgoodsclass.5.1": "Pengoksidasi (5.1)",
  "dangerousgoodsclass.6.1": "Beracun (6.1)",
  "dangerousgoodsclass.6.2": "Biohazard (6.2)",
  "dangerousgoodsclass.7": "Radioaktif (7)",
  "dangerousgoodsclass.8": "Korosif (8)",
  "dangerousgoodsclass.9": "Bermacam-macam (9)",
  "date.invalid": "Tanggal yang dipilih tidak valid",
  "datefilteroption.last3Months": "3 Bulan Terakhir",
  "datefilteroption.lastMonth": "Bulan lalu",
  "datefilteroption.lastWeek": "Minggu lalu",
  "datefilteroption.lastYear": "Tahun lalu",
  "field.duplicatedphonenumber": "Nomor telepon sudah ada",
  "field.invalid": "@@VALUE@@ tidak valid",
  "field.invalidinternalemail": "Email tidak valid dan harus disediakan oleh brenntag.com, brenntag-asia.com atau digib.com",
  "field.invalidphonenumber": "Nomor telepon tidak valid, gunakan format +61212345678",
  "field.required": "@@VALUE@@ Dibutuhkan",
  "filter.accessStatus": "Status akses",
  "filter.all": "Semua",
  "filter.allorders": "Semua perintah",
  "filter.allproducts": "Semua produk",
  "filter.apply": "Berlaku",
  "filter.brenntagOrderNumber": "Nomor pesanan Brenntag",
  "filter.compliancerequired": "Kepatuhan diperlukan",
  "filter.createddate": "Tanggal pembuatan",
  "filter.customerName": "Nama Pelanggan",
  "filter.customerNumber": "Nomor pelanggan",
  "filter.customerpo.placeholder": "Filter berdasarkan nomor PO pelanggan",
  "filter.customerponumber": "Nomor PO pelanggan",
  "filter.dangerousgoods": "Barang berbahaya",
  "filter.deliveryNumber": "Nomor pengiriman",
  "filter.deliverydate": "Tanggal pengiriman yang diminta",
  "filter.enddate": "Tanggal akhir",
  "filter.filterby": "Filter oleh",
  "filter.filters": "Filter",
  "filter.from": "dari",
  "filter.hazardous": "Barang - barang berbahaya",
  "filter.invoicenumber": "Nomor faktur",
  "filter.lastlogindate": "Tanggal login terakhir",
  "filter.myorders": "Pesananku",
  "filter.myproducts": "Produk saya",
  "filter.noresults": "Tidak ada hasil yang ditemukan",
  "filter.orderdate": "Tanggal pemesanan",
  "filter.otherfilters": "Filter lainnya",
  "filter.pill.accessStatus": "Status akses",
  "filter.pill.brenntagOrderNumber": "Urutan Brenntag #",
  "filter.pill.createdDate": "Tanggal pembuatan",
  "filter.pill.customerPONumber": "PO #",
  "filter.pill.dangerousGoods": "Barang berbahaya",
  "filter.pill.deliveryDate": "Tanggal pengiriman yang diminta",
  "filter.pill.dueDate": "Batas tanggal terakhir",
  "filter.pill.hazardousGoods": "Barang - barang berbahaya",
  "filter.pill.invoiceNumber": "Nomor faktur",
  "filter.pill.issueDate": "Tanggal faktur",
  "filter.pill.lastLoginDate": "Tanggal login",
  "filter.pill.orderDate": "Tanggal pemesanan",
  "filter.pill.packageType": "Jenis paket",
  "filter.pill.pricePointExists": "Tersedia untuk dipesan sekarang",
  "filter.pill.productName": "Nama Produk",
  "filter.pill.productNumber": "Nomor produk",
  "filter.pill.quoteDate": "Tanggal kutipan",
  "filter.pill.requestedDeliveryDate": "Pengiriman yang diminta",
  "filter.pill.resetAll": "Atur ulang semua filter",
  "filter.pill.role": "Wewenang",
  "filter.pill.salesGroupId": "Organisasi penjualan",
  "filter.pill.searchQuery": "Mencari",
  "filter.pill.shipToLocationId": "Dikirim ke",
  "filter.pill.status": "Status",
  "filter.pill.updatedDate": "Tanggal diperbarui",
  "filter.pill.userName": "Pengguna",
  "filter.placeholder.customerName": "Cari berdasarkan nama pelanggan",
  "filter.placeholder.customerNumber": "Cari berdasarkan nomor pelanggan",
  "filter.placeholder.global": "Cari produk, pesanan, atau faktur...",
  "filter.placeholder.userEmail": "Cari melalui email",
  "filter.placeholder.username": "Cari berdasarkan nama",
  "filter.pricePointExists": "Tersedia untuk dipesan sekarang",
  "filter.productName": "Nama Produk",
  "filter.quoteNumber": "Jumlah kutipan",
  "filter.quotedate": "Tanggal kutipan",
  "filter.role": "Wewenang",
  "filter.salesRepName": "Nama perwakilan penjualan",
  "filter.salesorganisation": "Organisasi penjualan",
  "filter.search-salesorg.placeholder": "Cari berdasarkan pelanggan atau organisasi penjualan",
  "filter.search.placeholder": "Pencarian",
  "filter.shipto": "Dikirim ke",
  "filter.startdate": "Mulai tanggal",
  "filter.status": "Status",
  "filter.until": "untuk",
  "filter.updated": "Diperbarui",
  "filter.user": "Pengguna",
  "filter.userEmail": "Email",
  "filter.userName": "Nama",
  "footer.contactus": "Hubungi Kami",
  "footer.faqs": "Tanya jawab",
  "footer.privacypolicy": "Perlindungan Data dan Pernyataan Privasi",
  "footer.termsofuse": "Ketentuan Penggunaan",
  "home.contact.1": "Hubungi Tim Brenntag Connect",
  "home.contact.2": "F.A.Q.",
  "home.heading.1": "Halo, @@USERNAME@@",
  "home.heading.2": "Selamat datang di Brenntag Connect!",
  "home.heading.3": "Brenntag Connect adalah platform online Anda untuk memudahkan pemesanan bahan kimia dan mengakses informasi terkini.",
  "home.heading.4": "Tindakan cepat",
  "home.invoices.list.1": "Lihat faktur",
  "home.invoices.list.2": "Unduh PDF faktur",
  "home.label.explore": "Menjelajahi",
  "home.label.viewinvoices": "Menampilkan semua faktur",
  "home.label.vieworders": "Lihat semua pesanan",
  "home.orders.list.1": "Melihat riwayat dan status pesanan",
  "home.orders.list.2": "Unduh Sertifikat Analisis",
  "home.products.list.1": "Cari Katalog Brenntag",
  "home.products.list.2": "Melihat dan Mengunduh dokumen SDS/TDS",
  "home.products.list.3": "Pesan Produk",
  "home.profile.list.1": "Ekspor data faktur",
  "home.profile.list.2": "Ekspor data pesanan",
  "home.profile.list.3": "Reset Kata Sandi",
  "home.recent.invoices.due": "Faktur terbaru jatuh tempo",
  "home.recent.invoices.issued": "Faktur yang baru-baru ini dikeluarkan",
  "home.recent.orders.created": "Pesanan yang baru dibuat",
  "home.recent.orders.updated": "Pesanan yang baru diperbarui",
  "invoice.customer": "pelanggan",
  "invoice.date": "Tanggal diterbitkan",
  "invoice.dueDate": "Tanggal jatuh tempo faktur",
  "invoice.noinvoicesfound": "Belum ada faktur yang tersedia. \nKami mengeluarkan faktur hanya setelah pengiriman pesanan lengkap.",
  "invoice.number": "Nomor faktur",
  "invoicestatus.Cancelled": "Dibatalkan",
  "invoicestatus.Open": "Buka",
  "invoicestatus.Paid": "Dibayar",
  "invoicestatus.PaidOnline": "Dibayar secara online",
  "invoicestatus.ProcessingPayment": "Memproses pembayaran",
  "isolanguage.en": "English",
  "isolanguage.id": "Bahasa Indonesia",
  "isolanguage.ko": "한국어",
  "isolanguage.th": "ไทย",
  "isolanguage.vi": "Tiếng Việt",
  "isolanguage.zh-CN": "中文（簡體）",
  "isolanguage.zh-TW": "中文（繁體）",
  "label.Landline": "Telepon rumah",
  "label.Mobile": "Seluler",
  "label.additionalinformation": "Informasi tambahan",
  "label.addresses": "Alamat",
  "label.alternativesizes": "Ukuran Alternatif",
  "label.amountdue": "Jumlah yang harus dibayar",
  "label.any": "Setiap",
  "label.anyquestions": "Ada pertanyaan?",
  "label.batchamount": "Jumlah batch",
  "label.batchnumber": "Nomor batch",
  "label.batchsize": "Ukuran batch",
  "label.billingaddress": "Alamat tagihan",
  "label.billtoaddress": "Alamat tagih ke",
  "label.billtoaddresses": "Alamat tagih ke",
  "label.billtoaddressincorrect": "Untuk mengubah detail alamat Anda, silakan hubungi kami melalui Obrolan",
  "label.billtoaddressrequired": "Alamat tagih ke wajib diisi",
  "label.brenntagordernumber": "Nomor pesanan Brenntag",
  "label.browseproducts": "Jelajahi produk",
  "label.browseusers": "Jelajahi pengguna",
  "label.button.attach": "Melampirkan",
  "label.button.changesalesorg": "Ya, ubah Organisasi Penjualan",
  "label.button.editprofile": "Edit Profil saya",
  "label.button.export": "Ekspor",
  "label.button.nokeep": "Tidak, Simpan",
  "label.button.update": "Pemutakhiran",
  "label.button.yesterminate": "Ya, Hentikan",
  "label.by": "oleh",
  "label.callus": "Hubungi kami",
  "label.cancel": "Membatalkan",
  "label.category": "Kategori",
  "label.changepassword": "Setel ulang kata sandi",
  "label.changesalesorg": "Ubah Organisasi Penjualan",
  "label.changesalesorgwarning": "Yakin ingin mengubah Organisasi Penjualan?",
  "label.checkingavailability": "Memeriksa ketersediaan…",
  "label.clickheretoreview": "Klik di sini untuk meninjau kami",
  "label.comments": "Komentar",
  "label.company": "Perusahaan",
  "label.confirmeddeliveryamount": "Jumlah pengiriman dikonfirmasi",
  "label.continueshopping": "Lanjutkan Belanja",
  "label.country": "Negara",
  "label.creationdate": "Tanggal pembuatan",
  "label.creditnote": "Nota kredit",
  "label.customer": "Pelanggan",
  "label.customername": "Nama Pelanggan",
  "label.customernumber": "Nomor pelanggan",
  "label.customerponumber": "Nomor PO pelanggan",
  "label.customerporeference": "Referensi PO pelanggan",
  "label.customerporeferencemaxlength": "Referensi PO pelanggan tidak boleh lebih dari @@LENGTH@@ karakter",
  "label.customerporeferencerequired": "Referensi PO pelanggan diperlukan",
  "label.dangerousgoodsclass": "Kelas barang berbahaya",
  "label.dangerousgoodscode": "DG",
  "label.datedelivered": "Tanggal pengiriman",
  "label.datefrom": "Tanggal dari",
  "label.dateissued": "Tanggal diterbitkan",
  "label.dateto": "Tanggal sampai",
  "label.debitnote": "Catatan debit",
  "label.defaultlanguage": "Bahasa",
  "label.delete": "Menghapus",
  "label.deliverynumber": "Nomor pengiriman",
  "label.details": "Detail",
  "label.discountperpack": "Diskon per paket",
  "label.distributionchannel": "Saluran distribusi",
  "label.division": "Divisi",
  "label.documents": "Unduh dokumen",
  "label.dontshowthis": "Jangan perlihatkan ini lagi",
  "label.download.all": "Unduh semua",
  "label.download.pdf": "Unduh PDF",
  "label.editmode": "mode edit",
  "label.email": "Alamat email",
  "label.emailaddress": "Alamat email",
  "label.exportdata": "Ekspor data",
  "label.exporting": "Mengekspor data, perlu beberapa saat ...",
  "label.exportingerror": "Terjadi kesalahan saat mengekspor file, coba lagi.",
  "label.exportinglonger": "Masih menghasilkan ekspor. Mungkin perlu waktu beberapa saat.",
  "label.exportingsuccess": "File data berhasil diekspor.",
  "label.exportordersinvoicescsv": "Ekspor data terstruktur dari pesanan dan faktur Anda langsung sebagai file CSV atau Excel (XLSX).",
  "label.exportselectcategory": "Pilih kategori dan rentang tanggal untuk file ekspor.",
  "label.externaluserfile": "File pengguna eksternal",
  "label.filesattached": "file terlampir",
  "label.from": "Dari:",
  "label.fullname": "Nama lengkap",
  "label.hazardousgoodscode": "HZ",
  "label.hazchem": "HazChem",
  "label.internaluserfile": "File pengguna internal",
  "label.invoice": "Faktur",
  "label.invoice.status.Cancelled": "Dibatalkan",
  "label.invoice.status.Open": "Buka",
  "label.invoice.status.Paid": "Dibayar",
  "label.invoice.status.PaidOnline": "Dibayar secara online",
  "label.invoice.status.ProcessingPayment": "Memproses pembayaran",
  "label.item": "barang",
  "label.items": "Item",
  "label.language": "Bahasa",
  "label.lastlogin": "Login terakhir",
  "label.learn_more_about_brenntag": "Pelajari lebih lanjut tentang Brenntag Connect",
  "label.logout": "Keluar",
  "label.minimumquantity": "Kuantitas minimum",
  "label.myprofile": "Profil saya",
  "label.name": "Nama lengkap",
  "label.next-step": "Langkah berikutnya",
  "label.no": "Tidak",
  "label.no-filesattached": "Tidak ada file yang dilampirkan",
  "label.no-filesuploaded": "Tidak ada file yang diunggah",
  "label.none": "Tidak",
  "label.nopriceavailable": "Tidak ada harga yang tersedia",
  "label.notes": "Catatan",
  "label.orderNumber": "Jumlah order",
  "label.orderamount": "Jumlah pesanan",
  "label.orderamount.zero": "Jumlah pesanan tidak boleh 0, Anda dapat menghapus produk di keranjang Anda.",
  "label.orderdate": "Tanggal pemesanan",
  "label.orderdetails": "Detail pesanan",
  "label.orderfiles": "Pesan file",
  "label.orderlist": "Daftar pesanan",
  "label.ordervalue": "Nilai pesanan",
  "label.pack": "Pak",
  "label.packaging": "Pengemasan",
  "label.packaginginformation": "Informasi kemasan",
  "label.packinggroup": "Kelompok pengepakan",
  "label.packsize": "Ukuran paket",
  "label.packtype": "Jenis paket",
  "label.paymentreference": "Referensi pembayaran",
  "label.paymentterms": "Syarat pembayaran",
  "label.payonline": "Bayar secara online",
  "label.personalinfo": "Informasi pengguna",
  "label.phonenumber": "Nomor telepon",
  "label.placeorder": "Tempatkan pesanan",
  "label.placingorder": "Menempatkan pesanan",
  "label.preferences": "Preferensi",
  "label.previous-step": "Langkah sebelumnya",
  "label.price": "Harga",
  "label.priceperpack": "Harga per paket",
  "label.pricesareexclusiveofsurcharges": "Harga belum termasuk biaya tambahan atau pajak.",
  "label.pricesaresubjecttochange": "Harga dapat berubah.",
  "label.productname": "Nama Produk",
  "label.productnumber": "Nomor produk",
  "label.products": "Produk",
  "label.producttype": "Tipe produk",
  "label.profile": "Profil",
  "label.purchaseOrderNumber": "Nomor PO pelanggan",
  "label.quantity": "Kuantitas",
  "label.quantity.minimumorderamount": "Jumlah harus lebih besar dari atau sama dengan @@MINIMUMORDERAMOUNT@@",
  "label.quantity.minimumorderquantity": "Kuantitas harus lebih besar dari atau sama dengan @@MINIMUMORDERQUANTITY@@",
  "label.quantity.tiereddiscounts": "Diskon kuantitas tersedia",
  "label.quantity.toolarge": "Nilainya terlalu besar",
  "label.quantity.zero": "Nilai harus lebih besar dari 0",
  "label.quotedate": "Tanggal kutipan",
  "label.quotenumber": "Jumlah kutipan",
  "label.records": "Item",
  "label.redirecttoadmin": "Buka antarmuka administrasi",
  "label.remove": "Menghapus",
  "label.removeproduct": "Hapus produk",
  "label.reorder": "Susun ulang",
  "label.reorderall": "Susun ulang semua",
  "label.requestcancellation": "Minta Pembatalan",
  "label.requestedamount": "Jumlah yang diminta",
  "label.requesteddeliverydate": "Tanggal pengiriman yang diminta",
  "label.requesteddeliverydate.tooltip": "Harap dicatat bahwa kami tidak selalu dapat menjamin tanggal pengiriman yang Anda minta. Pengiriman tergantung pada ketersediaan dan konfirmasi dari tim Brenntag kami.",
  "label.requesteddeliverydate.warning": "Tergantung ketersediaan dan konfirmasi oleh tim Brenntag.",
  "label.requesteddeliverydaterequired": "Tanggal pengiriman yang diminta diperlukan",
  "label.requestquote": "Minta kutipan",
  "label.retry": "Mencoba kembali",
  "label.role": "Wewenang",
  "label.role.Admin": "Admin",
  "label.role.CSR": "CSR",
  "label.role.ReadUser": "Baca Pengguna",
  "label.role.SuperAdmin": "Admin Super",
  "label.role.User": "Pengguna",
  "label.role.UserAdmin": "Admin Pengguna",
  "label.role.UserManager": "Manajer Pengguna",
  "label.salesorganisation": "Organisasi penjualan",
  "label.scheduleddeliverydate": "Tanggal pengiriman terjadwal",
  "label.selectpaymentmethod": "Pilih metode pembayaran Anda",
  "label.selectsalesorganisation": "Pilih organisasi penjualan",
  "label.shelflife": "Kehidupan rak",
  "label.shippinginstructions": "Instruksi pengiriman",
  "label.shipto": "Dikirim ke",
  "label.shiptoaddress": "Kirim ke Alamat",
  "label.shiptoaddresses": "Alamat pengiriman",
  "label.shiptoaddressincorrect": "Pemilihan ship-to penting karena memungkinkan harga yang benar untuk ditampilkan oleh lokasi pengiriman. Silakan hubungi kami melalui Chat jika alamat Ship-to Anda salah",
  "label.shiptoaddressrequired": "Alamat kirim ke wajib diisi",
  "label.shoppingcart": "Kereta Belanja",
  "label.size": "Ukuran",
  "label.soldtoaddress": "Alamat dijual ke",
  "label.sortby": "Sortir dengan",
  "label.specifications": "Spesifikasi",
  "label.statusacknowledged": "Diakui",
  "label.statusclosed": "Tutup",
  "label.statusopen": "Buka",
  "label.storageconditions": "Kondisi penyimpanan",
  "label.subtotal": "Subtotal",
  "label.tab.attachedfiles": "File-file terlampir",
  "label.tab.attachnew": "Lampirkan baru",
  "label.tax": "Pajak",
  "label.temperatureconditions": "Kondisi suhu",
  "label.termsandconditions": "Syarat dan Ketentuan",
  "label.timezone": "Zona waktu",
  "label.total": "Total",
  "label.type": "Mengetik",
  "label.unitprice": "Patokan harga",
  "label.unnumber": "Nomor UN",
  "label.updated": "Diperbarui",
  "label.user": "Pengguna",
  "label.validfrom": "Berlaku dari",
  "label.validto": "Berlaku untuk",
  "label.viewquote": "Lihat kutipan",
  "label.viewvideos": "Lihat Cara video",
  "label.yes": "Iya",
  "label.yourproductnumber": "Nomor produk Anda",
  "languageselection.modal.areyousure": "Yakin ingin mengubah bahasa?",
  "languageselection.modal.confirm": "Ya, ubah bahasa",
  "languageselection.modal.description": "Mengubah bahasa Anda akan memengaruhi semua email Anda dan setiap antarmuka pengguna di Brenntag Connect.",
  "languageselection.modal.title": "Mengubah bahasa yang disukai",
  "location.shipto.notavailable": "Produk ini tidak tersedia untuk pengiriman-ke-lokasi yang Anda pilih. Pilih lokasi lain.",
  "logout.changeswillbelost": "Perubahan pada halaman ini akan hilang jika Anda keluar.",
  "logout.confirmlogout": "Apakah anda yakin ingin melanjutkan?",
  "logout.itemsinyourshoppingcartcanbelost": "Item di keranjang Anda mungkin hilang jika Anda keluar.",
  "message.accessrestricted": "Tampaknya Anda tidak memiliki hak akses untuk melakukan apa yang Anda coba lakukan. Jika ini salah, harap hubungi administrator Anda.",
  "message.admincsrredirect": "Tampaknya Anda memiliki hak akses yang tinggi dan berada di tempat yang salah!",
  "message.areyousure": "Kamu yakin?",
  "message.changesalesorg": "Mengubah organisasi penjualan akan mempengaruhi katalog produk Anda, daftar pesanan, penawaran harga, faktur dan semua item saat ini di keranjang belanja di Brenntag Connect. Anda akan dapat mengubahnya kembali kapan pun Anda butuhkan.",
  "message.changeswillbelost": "Perubahan pada halaman ini akan hilang.",
  "message.documentnotfound": "Kesalahan telah diidentifikasi karena duplikat atau dokumen rusak, atau dokumen baru tidak dapat dimuat.",
  "message.noitemstoshow": "Maaf, tidak ada item untuk ditampilkan",
  "message.noprices": "Hubungi kami melalui chat untuk meminta harga produk ini",
  "message.pagenotfound": "Halaman ini sepertinya hilang",
  "message.productnaforshipto": "Pengiriman ke tidak tersedia untuk meminta penawaran harga. Pilih yang lain.",
  "order.cancelmodal.button": "Minta pembatalan pesanan",
  "order.cancelmodal.question": "Anda yakin ingin membatalkan pesanan berikut?",
  "order.cancelmodal.questionfollowup": "Setelah Anda mengkonfirmasi permintaan pembatalan, Anda tidak akan dapat mengembalikan tindakan tersebut",
  "order.cancelmodal.title": "Minta pembatalan pesanan",
  "order.cancelmodal.title.poabbr": "PO",
  "order.coadocument": "Dokumen CoA",
  "order.confirmationdocument": "Konfirmasi pesanan",
  "order.history.batch": "Batch",
  "order.history.batch_amount": "Jumlah batch",
  "order.history.bill_to": "Pembayaran kepada",
  "order.history.comment_from_user": "Komentar",
  "order.history.deliveryNumber": "Nomor pengiriman",
  "order.history.delivery_date": "Tanggal pengiriman",
  "order.history.delivery_information": "Informasi pengiriman",
  "order.history.hide": "Menyembunyikan",
  "order.history.missing_productname": "Nama Produk tidak tersedia.",
  "order.history.nologs": "Tidak ada log untuk pesanan ini.",
  "order.history.number": "Jumlah",
  "order.history.orderDetails": "Detail pesanan",
  "order.history.orderStatus": "Status pesanan",
  "order.history.order_amount": "Jumlah pesanan",
  "order.history.payment_terms": "Syarat pembayaran",
  "order.history.pricing_unit_value": "Nilai unit harga",
  "order.history.quantity_calculated": "Kuantitas dihitung",
  "order.history.requested_delivery_date": "Tanggal pengiriman yang diminta",
  "order.history.ship_to": "Dikirim ke",
  "order.history.shipping_instructions": "Instruksi pengiriman",
  "order.history.show": "Menunjukkan",
  "order.history.sold_to": "Dijual ke",
  "order.history.status": "Status",
  "order.history.subtotal_value": "Nilai subtotal",
  "order.history.title": "Log riwayat pesanan",
  "order.history.total_value": "Nilai total",
  "order.invoice.download": "Unduhan faktur",
  "order.invoice.title": "Faktur",
  "order.invoice.titlePlural": "Faktur",
  "order.invoice.view": "Melihat",
  "order.requestchange.allorderlinesdeleted": "Pesanan Anda harus memiliki setidaknya satu Produk agar tetap aktif. Untuk membatalkan pesanan, silakan pilih 'Minta pembatalan' atau hubungi kami melalui chat.",
  "order.requestchange.close": "Menutup",
  "order.requestchange.closeeditmode": "Tutup mode edit",
  "order.requestchange.closeeditmodeconfirmation": "Ya, tutup mode edit",
  "order.requestchange.closewarning": "Anda yakin ingin menutup permintaan perubahan?",
  "order.requestchange.discardedwarning": "Semua perubahan yang belum disimpan pada pesanan ini akan dibuang dan tidak akan dipertimbangkan.",
  "order.requestchange.leavewarning": "Anda yakin ingin meninggalkan halaman ini?",
  "order.requestchange.placechangerequest": "Tempatkan permintaan perubahan",
  "order.requestchange.productnotavailable": "Produk atau harga tidak tersedia lagi untuk permintaan perubahan, silahkan hubungi kami melalui chat.",
  "order.requestchange.requestchange": "Minta Perubahan",
  "order.requestchange.shiptoaddressnotavailable": "Alamat kirim-ke tidak tersedia untuk pesanan ini, silakan pilih alamat kirim-ke lain atau hubungi kami melalui obrolan.",
  "order.requestchange.shiptoaddressnotavailablewarning": "Alamat pengiriman tidak tersedia",
  "order.status.Acknowledged": "diakui",
  "order.status.Cancelled": "Dibatalkan",
  "order.status.Closed": "Tutup",
  "order.status.Confirmed": "Dikonfirmasi",
  "order.status.Invoiced": "Ditagih",
  "order.status.Open": "Buka",
  "order.status.OutForDelivery": "Dijadwalkan untuk pengiriman",
  "order.status.Submitted": "Diserahkan",
  "order.success.message": "Pesanan Anda sekarang dengan tim Brenntag untuk ditinjau. Setelah tinjauan ini selesai, Anda akan menerima konfirmasi yang menyoroti detail pengiriman. \n\nJika Anda memiliki pertanyaan atau ingin melakukan perubahan, silakan hubungi tim Brenntag melalui obrolan.",
  "order.success.title": "Pesanan Anda telah dikirim",
  "page.AccessRestricted": "Akses terbatas",
  "page.CustomerList": "Pelanggan",
  "page.Home": "Rumah",
  "page.InvoiceList": "Faktur",
  "page.NotFound": "Halaman tidak ditemukan (404)",
  "page.OrderList": "Pesanan",
  "page.PaymentInvoice": "Bayar secara online",
  "page.ProductList": "Produk",
  "page.Profile": "Profil saya",
  "page.QuoteList": "Tanda kutip",
  "page.SearchResultsFor": "Hasil Pencarian untuk",
  "page.TermsAndConditions": "Syarat dan Ketentuan",
  "page.TermsOfUse": "Ketentuan Penggunaan - Brenntag Connect",
  "page.UserList": "Pengguna",
  "paymentInvoice.error": "Faktur Anda tidak dapat diambil. Harap segarkan halaman dan coba lagi.",
  "paymentInvoice.infoCard.credit": "Kredit",
  "paymentInvoice.infoCard.creditcardStoreInfo": "Brenntag tidak menyimpan informasi kartu kredit pelanggan.",
  "paymentInvoice.infoCard.debitNote": "Catatan debit",
  "paymentInvoice.infoCard.downloadpdf": "Unduh PDF",
  "paymentInvoice.infoCard.invoice": "Faktur",
  "paymentInvoice.infoCard.price": "Harga",
  "paymentInvoice.infoCard.review": "Klik untuk meninjau kami",
  "paymentInvoice.infoCard.terms": "syarat dan Ketentuan",
  "paymentRedirect.error.heading": "Ada yang salah",
  "paymentRedirect.error.subtitle": "Silakan coba lagi atau hubungi kami melalui obrolan.",
  "paymentRedirect.error.title": "Ada kesalahan selama pembayaran dan nota faktur / debit tidak dibayar",
  "paymentRedirect.invoiceList": "Daftar faktur",
  "paymentRedirect.invoiceNumber": "Nomor faktur",
  "paymentRedirect.paidAmount": "Jumlah pembayaran",
  "paymentRedirect.paymentReference": "Referensi pembayaran",
  "paymentRedirect.pending.heading": "Menunggu konfirmasi",
  "paymentRedirect.pending.subtitle": "Setelah pembayaran dikonfirmasi, itu akan diproses oleh tim Brenntag dan statusnya akan diperbarui.",
  "paymentRedirect.pending.title": "Pembayaran Anda menunggu konfirmasi dari penyedia pembayaran",
  "paymentRedirect.refused.heading": "Pembayaran ditolak",
  "paymentRedirect.refused.subtitle": "Harap coba lagi menggunakan metode pembayaran lain.",
  "paymentRedirect.refused.title": "Pembayaran Anda ditolak dan karenanya tidak berhasil",
  "paymentRedirect.success.heading": "Terima kasih",
  "paymentRedirect.success.subtitle": "Faktur Anda telah dibayar. Tim Brenntag akan memproses pembayaran dan memperbarui status faktur.",
  "paymentRedirect.success.title": "Anda telah berhasil membayar dan permintaan Anda sedang diproses",
  "paymentterms.A001": "120 DAYS FROM INV DD, BY 15TH",
  "paymentterms.A002": "15 DAYS FROM INV DD, BY 25T",
  "paymentterms.A003": "15 DAYS FROM INV DD, BY 5TH",
  "paymentterms.A004": "30 DAYS FROM INV DATE, BY 10TH",
  "paymentterms.A005": "30 DAYS FROM INV DATE, BY 15TH",
  "paymentterms.A006": "30 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.A007": "30 DAYS FROM INV DATE, BY 25TH",
  "paymentterms.A008": "45 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.A009": "45 DAYS FROM INV DATE, BY 25TH",
  "paymentterms.A010": "60 DAYS FROM INV DATE, BY 10TH",
  "paymentterms.A011": "60 DAYS FROM INV DATE, BY 15TH",
  "paymentterms.A012": "60 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.A013": "60 DAYS FROM INV DATE, BY 25TH",
  "paymentterms.A014": "75 DAYS FROM INV DATE, BY EOM",
  "paymentterms.A015": "90 DAYS FROM INV DATE, BY 10TH",
  "paymentterms.A016": "90 DAYS FROM INV DATE, BY 15TH",
  "paymentterms.A017": "90 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.A018": "90 DAYS FROM INV DATE, BY 25TH",
  "paymentterms.A019": "60 DAYS FROM INV DATE, BY 26TH",
  "paymentterms.A020": "45 DAYS FROM INV DATE BY 10TH",
  "paymentterms.A021": "0-10:20,11-20:EoM,>=21 NxtM10",
  "paymentterms.A022": "INV 26-10:PAY 14,11-25: PAY 28",
  "paymentterms.A023": "CUT OFF 20TH, PAY ON 28TH",
  "paymentterms.A024": "45D FR INV;PAY 2ND/12TH/22ND",
  "paymentterms.A025": "45D (CUT-OFF 25TH) BY 15TH",
  "paymentterms.A026": "150D FROM INV DATE, PAY 25TH",
  "paymentterms.B004": "4 DAYS FROM INV DATE",
  "paymentterms.B005": "5 DAYS FROM INV DATE",
  "paymentterms.B007": "7 DAYS FROM INV DATE",
  "paymentterms.B009": "9 DAYS FROM INV DATE",
  "paymentterms.B010": "10 DAYS FROM INV DATE",
  "paymentterms.B013": "13 DAYS FROM INV DATE",
  "paymentterms.B014": "14 DAYS FROM INV DATE",
  "paymentterms.B015": "15 DAYS FROM INV DATE",
  "paymentterms.B018": "18 DAYS FROM INV DATE",
  "paymentterms.B020": "20 DAYS FROM INV. DATE",
  "paymentterms.B021": "21 DAYS FROM INV DATE",
  "paymentterms.B022": "22 DAYS FROM INV DATE",
  "paymentterms.B028": "28 DAYS FROM INV DATE",
  "paymentterms.B029": "29 DAYS FROM INV DATE",
  "paymentterms.B030": "30 DAYS FROM INV DATE",
  "paymentterms.B037": "37 DAYS FROM INV DATE",
  "paymentterms.B038": "38 DAYS FROM INV DATE",
  "paymentterms.B040": "40 DAYS FROM INV DATE",
  "paymentterms.B045": "45 DAYS FROM INV DATE",
  "paymentterms.B050": "50 DAYS FROM INV DATE",
  "paymentterms.B055": "55 DAYS FROM INV DATE",
  "paymentterms.B060": "60 DAYS FROM INV DATE",
  "paymentterms.B065": "65 DAYS FROM INV DATE",
  "paymentterms.B068": "68 DAYS FROM INV DATE",
  "paymentterms.B070": "70 DAYS FROM INV DATE",
  "paymentterms.B075": "75 DAYS FROM INV DATE",
  "paymentterms.B080": "80 DAYS FROM INV DATE",
  "paymentterms.B085": "85 DAYS FROM INV. DATE",
  "paymentterms.B090": "90 DAYS FROM INV DATE",
  "paymentterms.B105": "105 DAYS FROM INV DATE",
  "paymentterms.B120": "120 DAYS FROM INV DATE",
  "paymentterms.B150": "150 DAYS FROM INV DATE",
  "paymentterms.B180": "180 DAYS FROM INV DATE",
  "paymentterms.B360": "360 DAYS FROM INV DATE",
  "paymentterms.BA01": "50% ADV, BALANCE 30 DAYS INV",
  "paymentterms.BA02": "30% ADV, BALANCE 30 DAYS INV",
  "paymentterms.BA03": "60% ADV, 40% PDC UPON DEL 30D",
  "paymentterms.BA04": "30%TT ADV AND 70 % TT AT SIGHT",
  "paymentterms.BA05": "30%TT ADV AND 70 % DP AT SIGHT",
  "paymentterms.BA06": "80% TT ADV AND 20% TT AT SIGHT",
  "paymentterms.BA07": "20% TT ADV 80% DP AT SIGHT",
  "paymentterms.BA08": "28% TT ADV 72% 60D FR INV DATE",
  "paymentterms.BA09": "70% TT ADV 30% DP AT SIGHT",
  "paymentterms.BA10": "50% TT ADV 50% DP AT SIGHT",
  "paymentterms.BA11": "20% TT ADV 80% TT AT SIGHT",
  "paymentterms.BA12": "40% Advance, 60% B/L date",
  "paymentterms.BA13": "50% Advance, 50% BL date",
  "paymentterms.BA14": "50% ADV, BALANCE 45 DAYS INV",
  "paymentterms.BA15": "50% ADV BAL 45 DAYS BL DATE",
  "paymentterms.BA16": "50% TT ADV, 50 % LC AT SIGHT",
  "paymentterms.BA17": "50% ADV, 50% At SIGHT B/L COPY",
  "paymentterms.BA18": "70% TT ADV, 30% TT AT SIGHT",
  "paymentterms.BA19": "20% TT ADVANCE 80% COD",
  "paymentterms.BA20": "30% DP,70% after 60 days B/L",
  "paymentterms.BA21": "50% ADV, 50% AT SIGHT INV DATE",
  "paymentterms.BA22": "50% Advance 50% Immediate",
  "paymentterms.BA23": "70% TT AT SIGHT,30% TT 75 DAYS",
  "paymentterms.BA24": "50% TT ADV, 50% TT AT SIGHT",
  "paymentterms.BA25": "30% ADV, 70% BL DATE",
  "paymentterms.BA26": "10% DEP AGST PI, 90% TT@SIGHT",
  "paymentterms.BA27": "10% TT ADV, 90% DP AT SIGHT",
  "paymentterms.BA28": "15% TT ADV, 85% DP AT SIGHT",
  "paymentterms.BA29": "40% ADV, BAL COD",
  "paymentterms.BA30": "30% TT ADV, 70% 30D AFT B/L",
  "paymentterms.BA31": "90% CASH IN ADV, 10% TT 90DAYS",
  "paymentterms.BA32": "50% TT ADV, 50% TT 15D FR B/L",
  "paymentterms.BA33": "50% TT ADV, 50% 30D AFT B/L",
  "paymentterms.BA34": "60% ADV, 40% PDC UPON DEL 30D",
  "paymentterms.BA35": "50% ADV/50% 60DAYS FROM INVDAY",
  "paymentterms.BADV": "ADV PAYMENT",
  "paymentterms.BB05": "5 DAYS FROM BL DATE",
  "paymentterms.BB07": "7 DAYS FROM BL DATE",
  "paymentterms.BB10": "10 DAYS FROM BL DATE",
  "paymentterms.BB14": "14 DAYS FROM BL DATE",
  "paymentterms.BB15": "15 DAYS FROM BL DATE",
  "paymentterms.BB20": "20 DAYS FROM BL DATE",
  "paymentterms.BB21": "21 DAYS FROM BL DATE",
  "paymentterms.BB30": "30 DAYS FROM BL DATE",
  "paymentterms.BB35": "35 DAYS FROM BL DATE",
  "paymentterms.BB38": "38 DAYS FROM BL DATE",
  "paymentterms.BB40": "40 DAYS FROM BL DATE",
  "paymentterms.BB45": "45 DAYS FROM BL DATE",
  "paymentterms.BB46": "LC 45 DAYS FROM BL DATE",
  "paymentterms.BB50": "50 DAYS FROM BL DATE",
  "paymentterms.BB60": "60 DAYS FROM BL DATE",
  "paymentterms.BB65": "65 DAYS FROM BL DATE",
  "paymentterms.BB70": "70 DAYS FROM BL DATE",
  "paymentterms.BB75": "75 DAYS FROM BL DATE",
  "paymentterms.BB85": "85 DAYS FROM BL DATE",
  "paymentterms.BB90": "90 DAYS FROM BL DATE",
  "paymentterms.BB97": "97 DAYS FROM BL DATE",
  "paymentterms.BB98": "98 DAYS FROM BL DATE",
  "paymentterms.BB99": "99 DAYS FROM BL DATE",
  "paymentterms.BCBD": "CASH BEFORE DELIVERY",
  "paymentterms.BCOD": "CASH ON DELIVERY",
  "paymentterms.BD01": "D/A 15 DAYS FROM B/L DATE",
  "paymentterms.BD02": "D/A 30 DAYS FROM B/L DATE",
  "paymentterms.BD03": "D/A 45 DAYS FROM B/L DATE",
  "paymentterms.BD04": "D/A 60 DAYS FROM B/L DATE",
  "paymentterms.BD05": "D/A 75 DAYS FROM B/L DATE",
  "paymentterms.BD06": "D/A 90 DAYS FROM B/L DATE",
  "paymentterms.BD07": "D/A 120 DAYS FROM B/L DATE",
  "paymentterms.BD12": "DOC AGNST ACCEPTANCE 120 DAYS",
  "paymentterms.BD15": "DOC AGNST ACCEPTANCE 15 DAYS",
  "paymentterms.BD30": "DOC AGNST ACCEPTANCE 30 DAYS",
  "paymentterms.BD45": "DOC AGNST ACCEPTANCE 45 DAYS",
  "paymentterms.BD60": "DOC AGNST ACCEPTANCE 60 DAYS",
  "paymentterms.BD75": "DOC AGNST ACCEPTANCE 75 DAYS",
  "paymentterms.BD90": "DOC AGNST ACCEPTANCE 90 DAYS",
  "paymentterms.BDAA": "DOCUMENTS AGNST ACCEPTANCE",
  "paymentterms.BDAP": "DOC AGNST ACCEPTANCE AT SIGHT",
  "paymentterms.BE00": "0 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.BE14": "15 DAYS FR INV DD, EOM BY 20TH",
  "paymentterms.BE15": "15 DAYS FR BL DD, EOM BY 20TH",
  "paymentterms.BE16": "15 DAYS EOM",
  "paymentterms.BE20": "20DAYS FR INV DD, EOM BY 20TH",
  "paymentterms.BE21": "20 DAYS FR BL DD, EOM BY 20TH",
  "paymentterms.BE22": "20 DAYS FR BL DD, EOM BY 20TH",
  "paymentterms.BE23": "20 DAYS EOM BY 25TH",
  "paymentterms.BE30": "30 DAYS EOM BY 20TH",
  "paymentterms.BE31": "EOM BY 25TH",
  "paymentterms.BE32": "32 days end of month by 2nd",
  "paymentterms.BE33": "60 days end of month by 2nd",
  "paymentterms.BE45": "45 DAYS EOM",
  "paymentterms.BE60": "60 DAYS EOM",
  "paymentterms.BE61": "60 DAYS EOM BY 20TH",
  "paymentterms.BE62": "60 DAYS EOM BY 15TH",
  "paymentterms.BE63": "60 days end of month by 4th",
  "paymentterms.BE90": "90 DAYS EOM",
  "paymentterms.BE91": "90 DAYS EOM BY 5TH",
  "paymentterms.BIMM": "IMMEDIATE",
  "paymentterms.BL15": "LC 15 DAYS AT SIGHT",
  "paymentterms.BL21": "LC 21 DAYS AT SIGHT",
  "paymentterms.BL30": "LC 30 DAYS AT SIGHT",
  "paymentterms.BL45": "LC 45 DAYS AT SIGHT",
  "paymentterms.BL60": "LC 60 DAYS AT SIGHT",
  "paymentterms.BL61": "LC 60 DAYS BL",
  "paymentterms.BL75": "LC 75 DAYS AT SIGHT",
  "paymentterms.BL90": "LC 90 DAYS AT SIGHT",
  "paymentterms.BL91": "LC 90 DAYS BL",
  "paymentterms.BLAS": "LC PAYMENT AT SIGHT",
  "paymentterms.BP12": "DOCUMENTS AGNST PAYTS 120 DAYS",
  "paymentterms.BP30": "DOCUMENTS AGNST PAYTS 30 DAYS",
  "paymentterms.BP60": "DOCUMENTS AGNST PAYTS 60 DAYS",
  "paymentterms.BPAA": "D/P AT SIGHT",
  "paymentterms.BTAS": "TT AT SIGHT",
  "paymentterms.CAD1": "CASH AGAINST DOCUMENT",
  "paymentterms.CBO1": "CBO",
  "paymentterms.CBO2": "30% CBO, 70% CBD",
  "paymentterms.CBO3": "50% CBO, 50% CBD",
  "paymentterms.CBO4": "50% CBO, 50% COD",
  "paymentterms.CBO5": "50% CBO, 50% 30 DAYS FROM INV",
  "paymentterms.CNMT": "CNMT - CONSIGNMENT",
  "paymentterms.D001": "TT AGAINST DOCUMENT",
  "paymentterms.D002": "TT IN ADVANCE",
  "paymentterms.D004": "TT EOM 30D BY 20TH FRM BL DD",
  "paymentterms.D005": "TT 30 DAYS FROM INVOICE DATE",
  "paymentterms.D006": "TT 45 DAYS FROM BL DATE",
  "paymentterms.D007": "TT 45 DAYS FROM INV DATE",
  "paymentterms.D008": "TT 60 DAYS FROM INVOICE DATE",
  "paymentterms.D010": "TT 65 DAYS FROM  B/L Date",
  "paymentterms.D011": "TT 25 DAYS FROM INVOICE DATE",
  "paymentterms.D012": "TT AGAINST BL",
  "paymentterms.D013": "7 DAYS T/T AT SIGHT",
  "paymentterms.D014": "T/T BEFORE DELIVERY",
  "paymentterms.D015": "TT UPON ORDER CONFIRMATION",
  "paymentterms.D016": "TT 2 DAYS FROM INVOICE DATE",
  "paymentterms.D017": "TT 90 DAYS FROM INVOICE DATE",
  "paymentterms.DD01": "DIRECT DEBIT 30 DAYS",
  "paymentterms.DD02": "DIRECT DEBIT 60 DAYS",
  "paymentterms.DD03": "DIRECT DEBIT 90 DAYS",
  "paymentterms.E001": "EOM 30 DAYS BY 10TH",
  "paymentterms.E002": "EOM 30 DAYS BY 15TH",
  "paymentterms.E003": "EOM 30 DAYS BY 20TH",
  "paymentterms.E004": "EOM 30 DAYS BY 25TH",
  "paymentterms.E005": "EOM 60 DAYS BY 10TH",
  "paymentterms.E006": "EOM 60 DAYS BY 15TH",
  "paymentterms.E007": "EOM 60 DAYS BY 20TH",
  "paymentterms.E008": "EOM 60 DAYS BY 25TH",
  "paymentterms.E009": "EOM 90 DAYS BY 10TH",
  "paymentterms.E010": "EOM 90 DAYS BY 15TH",
  "paymentterms.E011": "EOM 90 DAYS BY 20TH",
  "paymentterms.E012": "EOM 90 DAYS BY 25TH",
  "paymentterms.E013": "EOM",
  "paymentterms.E014": "EOM 30 DAYS",
  "paymentterms.E015": "EOM 30 DAYS BY 5th",
  "paymentterms.E016": "EOM 30 DAYS BY 10th",
  "paymentterms.E017": "EOM 30D BY 20th",
  "paymentterms.E018": "EOM 30D BY 25th",
  "paymentterms.E019": "EOM 30 DAYS (CUT-OFF 25th)",
  "paymentterms.E020": "EOM 30D (CUT-OFF 25th) BY 5TH",
  "paymentterms.E021": "EOM 30D (CUT-OFF 25th) BY 10TH",
  "paymentterms.E022": "EOM 45 DAYS (CUT-OFF 25th)",
  "paymentterms.E023": "EOM 60 DAYS",
  "paymentterms.E024": "EOM 60 DAYS BY 5th",
  "paymentterms.E025": "EOM 60 DAYS BY 10th",
  "paymentterms.E026": "EOM 60 DAYS BY 15th",
  "paymentterms.E027": "EOM 60 DAYS (CUT-OFF 25th)",
  "paymentterms.E028": "EOM 60D (CUT-OFF 25th) BY 5TH",
  "paymentterms.E029": "EOM 60D (CUT-OFF 25th) BY 10TH",
  "paymentterms.E030": "EOM 90 DAYS",
  "paymentterms.E031": "EOM 90 DAYS BY 7TH",
  "paymentterms.E032": "EOM 90 DAYS (CUT-OFF 20th)",
  "paymentterms.E033": "EOM 90 DAYS (CUT-OFF 25th)",
  "paymentterms.E034": "EOM BY 5TH",
  "paymentterms.E035": "EOM BY 10TH",
  "paymentterms.E036": "EOM 30D (CUT-OFF 20th) BY 15TH",
  "paymentterms.E037": "EOM 90D (CUT-OFF 25th) by 7th",
  "paymentterms.E038": "EOM 45 DAYS (CUT-OFF 25) BY 5",
  "paymentterms.E039": "EOM 60 DAYS (CUT-OFF 20th)",
  "paymentterms.E040": "EOM 90 DAYS (CUT-OFF 25) BY 8",
  "paymentterms.E041": "EOM 60 DAYS (CUT-OFF 25th) 15",
  "paymentterms.E042": "EOM 90 DAYS (CUT-OFF 25th) 5th",
  "paymentterms.E043": "EOM 90 DAYS (CUT-OFF 25th) 10",
  "paymentterms.E044": "EOM 90 DAYS (CUT-OFF 25th)15",
  "paymentterms.E045": "EOM 90 DAYS (CUT-OFF 25th)20th",
  "paymentterms.E046": "EOM 120 DAYS(CUT-OFF 25th)15th",
  "paymentterms.E047": "EOM 30 DAYS (CUT-OFF 25th)15th",
  "paymentterms.E048": "DUE SAME DAY NEXT MTH",
  "paymentterms.E049": "EOM 30 DAYS (DUE ON 27TH)",
  "paymentterms.E050": "EOM 60 DAYS DUE 25th",
  "paymentterms.E051": "EOM 210D",
  "paymentterms.E052": "EOM 105D",
  "paymentterms.E053": "EOM 60 DAYS (CUT-OFF 20TH) 20",
  "paymentterms.E054": "EOM 30 DAYS (CUT-OFF  20th)",
  "paymentterms.E055": "EOM 30D (CUT_OFF 25TH) BY 16TH",
  "paymentterms.E056": "EOM 85D (CUT-OFF 25TH)",
  "paymentterms.E057": "EOM 90D (DUE 5TH FOLLOWING)",
  "paymentterms.E058": "EOM 120D",
  "paymentterms.E059": "EOM (CUT-OFF 25TH) BY 5TH",
  "paymentterms.E060": "EOM 45 DAYS BY 15TH",
  "paymentterms.E061": "64 DAYS FROM EOM",
  "paymentterms.E062": "EOM BY 10TH",
  "paymentterms.E063": "EOM BY 26TH",
  "paymentterms.E064": "EOM 31 days",
  "paymentterms.E065": "EOM 50 DAYS (CUT-OFF 24th)",
  "paymentterms.E120": "120 DAYS EOM",
  "paymentterms.EA65": "65 DAYS ETA",
  "paymentterms.EM15": "EOM 15 DAYS",
  "paymentterms.EM20": "EOM 20 DAYS",
  "paymentterms.EM30": "30 DAYS EOM",
  "paymentterms.EM45": "EOM 45 DAYS",
  "paymentterms.EM65": "EOM 65 DAYS",
  "paymentterms.EM75": "EOM 75 DAYS",
  "paymentterms.EQ01": "End of Quarter (by 20th)",
  "paymentterms.GR10": "10 DAYS AFTER GOODS RECEIPT",
  "paymentterms.GR30": "30 DAYS AFTER GOODS RECEIPT",
  "paymentterms.IK00": "Within 5 days 3% cash discount",
  "paymentterms.L001": "LC 150 DAYS AT SIGHT",
  "paymentterms.L002": "LC 180 DAYS AT SIGHT",
  "paymentterms.L003": "LC 105 DAYS BL",
  "paymentterms.L004": "LC 120 DAYS BL",
  "paymentterms.L005": "LC 150 DAYS BL",
  "paymentterms.L006": "LC 180 DAYS BL",
  "paymentterms.L007": "LC 15 DAYS BL",
  "paymentterms.L030": "LC 30 DAYS BL",
  "paymentterms.L105": "105 DAYS FROM BL DATE",
  "paymentterms.L120": "120 DAYS FROM BL DATE",
  "paymentterms.L150": "150 DAYS FROM BL DATE",
  "paymentterms.L180": "L 180 DAYS FROM BL DATE",
  "paymentterms.LD01": "LAST DAY NEXT MTH",
  "paymentterms.LD02": "LAST DAY OF MTH AFT NEXT MTH",
  "paymentterms.LD03": "LAST DAY OF THREE MONTH LATER",
  "paymentterms.LVT0": "16 days 2%, 31 days net",
  "paymentterms.M001": "3 MONTH LATER BY 5TH",
  "paymentterms.M002": "3 MONTH LATER BY 5TH",
  "paymentterms.MVT0": "10 days 3%, 16  2%, 31 net",
  "paymentterms.P001": "60 DAYS ETA",
  "paymentterms.P002": "90 DAYS ETA",
  "paymentterms.P003": "15 DAYS FROM ETA HCM PORT",
  "paymentterms.P004": "60 DAYS FROM ETA, PAY ON 26TH",
  "paymentterms.PBD1": "PDC BEFORE DEL 30 DAYS",
  "paymentterms.PBD2": "PDC BEFORE DEL 45 DAYS",
  "paymentterms.PBD3": "PDC BEFORE DEL 60 DAYS",
  "paymentterms.PBD4": "PDC BEFORE DEL 90DAYS FROM INV",
  "paymentterms.PBD5": "PDC BEFORE DEL 15 DAYS",
  "paymentterms.PDC1": "30 DAYS PDC FROM INV DATE",
  "paymentterms.PDC2": "60 DAYS PDC FROM INV DATE",
  "paymentterms.PDC3": "45 DAYS PDC FROM INV DATE",
  "paymentterms.PDC4": "15 DAYS PDC FROM INV DATE",
  "paymentterms.PDC5": "90 DAYS PDC FROM INV DATE",
  "paymentterms.PUD1": "PDC UPON DEL 15 DAYS FROM INV",
  "paymentterms.PUD2": "PDC UPON DEL 30 DAYS FROM INV",
  "paymentterms.PUD3": "PDC UPON DEL 45 DAYS FROM INV",
  "paymentterms.PUD4": "PDC UPON DEL 60 DAYS FROM INV",
  "paymentterms.PUD5": "PDC UPON DEL 90 DAYS FROM INV",
  "paymentterms.TX07": "7 DAYS AFTER STOCK ARRIVAL",
  "paymentterms.TX30": "30 DAYS DECLARATION",
  "paymentterms.TX45": "45 DAYS DECLARATION",
  "paymentterms.TX60": "60 DAYS DECLARATION",
  "paymentterms.TX90": "90 DAYS DECLARATION",
  "paymentterms.WALL": "99% forever",
  "paymentterms.WL01": "12 days net",
  "paymentterms.Z001": "custom payment term (test)",
  "paymentterms.ZB00": "Pay immediately w/o deduction",
  "paymentterms.ZB01": "14 Days 3%, 30/2%, 45 net",
  "paymentterms.ZB02": "8 days 5%, 14/2%, 21 net",
  "paymentterms.ZB03": "20 days 2%, 30 days net",
  "paymentterms.ZB04": "10 days 4%, 20/2%, 30 net",
  "paymentterms.ZB05": "5 days 2%, 10 days net",
  "phone.landline": "Telepon rumah",
  "phone.mobile": "Telepon genggam",
  "product.altsizes.loadmore": "Muat lebih banyak ukuran alternatif",
  "product.discount.saveamount": "Simpan @@AMOUNT@@",
  "product.discount.savingspercentage": "Tabungan @@PERCENTAGE@@",
  "product.documentType.msds": "Dokumen SDS",
  "product.documentType.tds": "Dokumen TDS",
  "product.documenterror": "Tak bisa mengambil dokumen",
  "product.loadingdocuments": "Memuat dokumen",
  "product.nodocuments": "Tidak ada dokumen yang tersedia",
  "product.safetyinformation": "Informasi keselamatan",
  "product.type.nonvaluated": "Materi yang Tidak Divalidasi",
  "product.type.packaging": "Pengemasan",
  "product.type.returnable": "Paket yang dapat dikembalikan",
  "product.type.sample": "Sampel",
  "product.type.services": "Jasa",
  "product.type.tolling": "Toling",
  "product.type.tolling-raw-material-nonvaluated": "Bahan baku tol tidak dinilai",
  "product.type.tradinggoods": "Barang perdagangan",
  "quote.date": "Tanggal kutipan",
  "quote.decline": "Tolak kutipan",
  "quote.details": "Detail kutipan",
  "quote.number": "Jumlah kutipan",
  "quote.requoteproduct": "Requote produk",
  "quote.validfrom": "Berlaku dari",
  "quote.validto": "Berlaku untuk",
  "quote.value": "Nilai kutipan",
  "quotestatus.Declined": "Ditolak",
  "quotestatus.Expired": "Kedaluwarsa",
  "quotestatus.InProgress": "Sedang berlangsung",
  "quotestatus.Open": "Buka",
  "quotestatus.Ordered": "Dipesan",
  "quotestatus.Submitted": "Diserahkan",
  "quotestatus.Upcoming": "Mendatang",
  "regex.placeordertermsandconditions": "Dengan melakukan pemesanan, Anda menerima @@TERMS_AND_CONDITIONS@@",
  "regex.reviewtermsandconditions": "Klik di sini untuk meninjau @@TERMS_AND_CONDITIONS@@",
  "requestcancellation.request": "Tim Layanan Pelanggan Brenntag, saya ingin meminta pembatalan pesanan dengan nomor pesanan: @@ORDER_NUMBER@@ dan nomor pelanggan: @@CUSTOMER_NUMBER@@. Harap berikan konfirmasi atau informasi lebih lanjut sesuai kebutuhan.",
  "requestchanges.message.billToAddress": "- Alamat penagihan sebelumnya: \n@@LOCATION_OLD@@ \n\n- Alamat penagihan baru: \n@@LOCATION_NEW@@",
  "requestchanges.message.cancelproduct": "- Batalkan produk ini: \n\nProduk: @@PRODUCT_NAME@@ \nID Produk: @@PRODUCT_NUMBER@@",
  "requestchanges.message.comments": "- Komentar: \n@@COMMENTS_OLD@@ → @@COMMENTS_NEW@@",
  "requestchanges.message.deliverydate": "- Tanggal pengiriman yang diminta: \n@@DATE_OLD@@ → @@DATE_NEW@@",
  "requestchanges.message.heading": "Tim Layanan Pelanggan Brenntag, dapatkah Anda mengubah informasi berikut untuk pesanan saya: \n\nNomor pelanggan @@CUSTOMER_NUMBER@@ \nNomor pesanan @@PURCHASE_ORDER_NUMBER@@ \n\n---------",
  "requestchanges.message.orderline": "- Ubah produk ini: \n\nProduk: @@PRODUCT_NAME@@ \nID Produk: @@PRODUCT_NUMBER@@ \n- Jumlah: @@QUANTITY_OLD@@ → @@QUANTITY_NEW@@ \n- Jumlah: @@AMOUNT_OLD@@ @@AMOUNT_UOM_OLD@@ → @@AMOUNT_NEW@@ @@AMOUNT_UOM_NEW@@",
  "requestchanges.message.shipToAddress": "- Alamat pengiriman sebelumnya: \n@@LOCATION_OLD@@ \n\n- Alamat pengiriman baru: \n@@LOCATION_NEW@@",
  "requestquote.request": "Tim Layanan Pelanggan Brenntag, berikan penawaran untuk hal berikut: \n\nNomor pelanggan @@CUSTOMER_NUMBER @@ \n\nProduk: @@PRODUCT_NAME@@ \n\nID Produk: @@PRODUCT_NUMBER@@ \n\nKuantitas yang diminta: @@QUANTITY@@ \n\nJumlah yang diminta: @@REQUESTED_AMOUNT@@ \n\nAlamat pengiriman: @@SHIP_TO_ADDRESS@@ \n\nTanggal Pengiriman yang Diminta: @@REQUESTED_DELIVERY_DATE@@",
  "show_more.less": "Tampilkan lebih sedikit",
  "show_more.more": "Menampilkan lebih banyak",
  "show_more.results": "Tampilkan hasil lainnya",
  "something.wrong": "Ups! Ada yang salah. Silahkan coba lagi",
  "something.wrong.documents": "Ups! Ada yang salah",
  "sortinglabel.-currency": "Mata uang (ZA)",
  "sortinglabel.-customerName": "Nama pelanggan (ZA)",
  "sortinglabel.-dueDate": "Tanggal jatuh tempo terbaru",
  "sortinglabel.-grossAmount.amount": "Jumlah yang harus dibayar paling tinggi",
  "sortinglabel.-invoiceNumber": "Nomor faktur (ZA)",
  "sortinglabel.-issueDate": "Tanggal dikeluarkan terbaru",
  "sortinglabel.-lastLoggedInAt": "Login terakhir terbaru",
  "sortinglabel.-lastUpdateDate": "Diperbarui terbaru",
  "sortinglabel.-name": "Nama produk (ZA)",
  "sortinglabel.-netAmount": "Jumlah bersih tertinggi",
  "sortinglabel.-orderCreationDate": "Tanggal pemesanan terbaru",
  "sortinglabel.-packaging.name": "Jenis paket (ZA)",
  "sortinglabel.-quoteCreationDate": "Tanggal kutipan terbaru",
  "sortinglabel.-username": "Nama (ZA)",
  "sortinglabel.-usertype": "Jenis pengguna (Eksternal dulu)",
  "sortinglabel.currency": "Mata uang (AZ)",
  "sortinglabel.customerName": "Nama pelanggan (AZ)",
  "sortinglabel.dueDate": "Tanggal jatuh tempo terlama",
  "sortinglabel.grossAmount.amount": "Jumlah terutang terendah",
  "sortinglabel.invoiceNumber": "Nomor faktur (AZ)",
  "sortinglabel.issueDate": "Tanggal dikeluarkan terlama",
  "sortinglabel.lastLoggedInAt": "Login terakhir terlama",
  "sortinglabel.lastUpdateDate": "Diperbarui terlama",
  "sortinglabel.name": "Nama produk (AZ)",
  "sortinglabel.netAmount": "Jumlah bersih terendah",
  "sortinglabel.orderCreationDate": "Tanggal pemesanan terlama",
  "sortinglabel.packaging.name": "Jenis paket (AZ)",
  "sortinglabel.quoteCreationDate": "Tanggal kutipan terlama",
  "sortinglabel.relevance": "Relevansi",
  "sortinglabel.username": "Nama (AZ)",
  "sortinglabel.usertype": "Jenis pengguna (Internal dulu)",
  "storageconditions.01": "Penyimpanan Umum-Makanan, Farmasi",
  "storageconditions.02": "Penyimpanan Umum",
  "storageconditions.03": "Penyimpanan Berbahaya",
  "storageconditions.04": "Ruang Penyimpanan Makanan Dingin, Farmasi",
  "storageconditions.05": "Ambien yang Mudah Terbakar",
  "storageconditions.06": "Ruang Penyimpanan Cool",
  "storageconditions.07": "Ruang Penyimpanan Freezer",
  "storageconditions.08": "Penyimpanan Flurokimia",
  "storageconditions.09": "Penyimpanan Amonia",
  "storageconditions.10": "Penyimpanan Tidak Sesuai",
  "storageconditions.11": "Penyimpanan Cairan Massal",
  "storageconditions.12": "Area produksi",
  "support.email": "support@brenntagconnect.com",
  "support.email.salesgroup.NL01": "orders.au@brenntag-asia.com",
  "support.email.topic": "Pertanyaan: {customer PO#}/ {quotation #}/ {customer ID}",
  "support.phonenumber": "+123 3453 043",
  "temperatureconditions.01": "> 25 hingga 40ºC",
  "temperatureconditions.02": "> 15 hingga 25ºC dengan kelembapan terkontrol",
  "temperatureconditions.03": "> 8 hingga 15ºC dengan kelembapan terkontrol",
  "temperatureconditions.04": "> 0 hingga 8ºC dengan kelembapan terkontrol",
  "temperatureconditions.05": "> -20 hingga 0ºC",
  "temperatureconditions.06": "-20ºC & lebih rendah",
  "terms.agree": "Ya saya setuju",
  "terms.description": "Dengan mengakses atau menggunakan bagian mana pun dari Brenntag Connect, Anda setuju untuk terikat oleh Ketentuan Penggunaan ini.\n\nJika Anda tidak menyetujui semua syarat dan ketentuan perjanjian ini, Anda tidak dapat mengakses Brenntag Connect atau menggunakan layanannya",
  "terms.disagree": "Tidak, keluar",
  "timeunit.many.day": "hari",
  "timeunit.many.month": "bulan",
  "timeunit.many.week": "minggu",
  "timeunit.many.year": "tahun",
  "timeunit.one.day": "hari",
  "timeunit.one.month": "bulan",
  "timeunit.one.week": "minggu",
  "timeunit.one.year": "tahun",
  "toast.error.coadocuments": "Ada yang salah saat mengambil dokumen CoA",
  "toast.error.createuser": "Ada yang salah saat membuat pengguna",
  "toast.error.customernotfound": "Ada yang salah. Silakan hubungi Brenntag Connect.",
  "toast.error.customers": "Terjadi masalah saat mengambil pelanggan",
  "toast.error.invoices": "Ada yang salah saat mengambil data faktur",
  "toast.error.languagechange": "Perubahan bahasa gagal",
  "toast.error.orderdetails": "Ada yang salah saat mengambil detail pesanan",
  "toast.error.orders": "Ada yang salah saat mengambil riwayat pesanan",
  "toast.error.placingorder": "Ada yang salah saat melakukan pemesanan",
  "toast.error.price": "Ada yang salah saat mengambil harga",
  "toast.error.productdocuments": "Ada yang salah mengambil dokumen produk",
  "toast.error.products": "Ada yang salah saat mengambil data produk",
  "toast.error.quote": "Ada yang salah saat mengambil detail kutipan",
  "toast.error.quotereject": "Ada yang salah saat menolak kutipan",
  "toast.error.quotes": "Ada yang salah saat mengambil kutipan",
  "toast.error.saveuser": "Ada yang salah saat menyimpan perubahan pengguna",
  "toast.error.userinfo": "Ada yang salah saat mengambil informasi pengguna",
  "toast.error.userservice": "Ada yang salah saat mengambil data pengguna",
  "toast.error.userservice.emailaddressexists": "Pengguna dengan alamat email @@EMAIL@@ sudah ada",
  "toast.error.userservice.permissionsoutsidesalesgroup": "Anda tidak dapat membuat atau mengubah pengguna yang berada di luar grup penjualan yang ditetapkan untuk Anda",
  "toast.error.userservice.savefailed": "Ada yang salah saat menyimpan data pengguna",
  "toast.error.validatingcart": "Ada yang salah saat memvalidasi keranjang",
  "toast.success.createuser": "Pengguna @@USER@@ berhasil dibuat",
  "toast.success.deleteuser": "Pengguna @@USER@@ berhasil dihapus",
  "toast.success.resetpassword": "Kami baru saja mengirimi Anda email di @@EMAIL@@ mengatur ulang kata sandi Anda.",
  "toast.success.saveuser": "Pengguna @@USER@@ berhasil disimpan",
  "user.accessrights": "Hak akses dan Bahasa",
  "user.accessrights.message": "Tetapkan hak akses kepada pelanggan",
  "user.bcaccessstatus": "Status akses Brenntag Connect",
  "user.create": "Buat pengguna",
  "user.createdon": "Dibuat pada",
  "user.delete.confirmation": "Ini tidak bisa dibatalkan, lanjutkan?",
  "user.delete.message": "Pengguna @@USER@@ akan dihapus secara permanen dari sistem.",
  "user.edit": "Edit pengguna",
  "user.information": "Informasi pengguna",
  "user.lastpasswordreset": "Reset kata sandi terakhir",
  "user.modal.terminate.confirmation": "Apakah Anda yakin ingin menghentikan pengguna ini?",
  "user.modal.terminate.message": "Peringatan: Pengguna yang dihentikan tidak akan lagi dapat masuk ke Brenntag Connect.",
  "user.notes": "Catatan",
  "user.notes.placeholder": "Contoh: info jam kerja, kontak cadangan",
  "user.role": "Wewenang",
  "user.save": "Simpan perubahan",
  "user.search.customer": "Cari nomor atau nama Pelanggan",
  "user.selectcustomer": "Pilih pelanggan",
  "user.selectlanguage": "Pilih bahasa",
  "user.view": "Lihat pengguna",
  "userEdit.cancel.confirm": "Anda yakin ingin membatalkan?",
  "userEdit.cancel.create.external": "Batalkan 'buat pengguna eksternal'",
  "userEdit.cancel.create.internal": "Batalkan 'buat pengguna internal'",
  "userEdit.cancel.edit.external": "Batalkan 'edit pengguna eksternal'",
  "userEdit.cancel.edit.internal": "Batalkan 'edit pengguna internal'",
  "userEdit.message.cannotedit": "Anda tidak dapat mengedit detail pengguna untuk pengguna ini. Silakan hubungi Brenntag, jika Anda ingin mengedit pengguna ini.",
  "userrole.Admin": "Admin",
  "userrole.CSR": "CSR",
  "userrole.ReadUser": "Pengguna hanya-baca",
  "userrole.SuperAdmin": "Administrator Super",
  "userrole.User": "Pengguna",
  "userrole.UserAdmin": "Administrator Pengguna",
  "userrole.UserManager": "Manajer Pengguna",
  "userrole.description": "Peran pengguna",
  "validationerror.invalid-date": "Tanggal yang dipilih tidak valid",
  "validationerror.invalid-moq": "Jumlah yang dipilih di bawah jumlah pesanan minimum",
  "validationerror.not-authorized": "Tidak diizinkan",
  "validationerror.not-found": "Produk ini tidak ada",
  "validationerror.price-changed": "Harga produk ini telah diperbarui",
  "validationerror.price-mismatch": "Beberapa harga telah diperbarui",
  "validationerror.price-not-found": "Harga tidak ditemukan untuk produk ini. Silakan hubungi kami melalui Obrolan untuk meminta harga.",
  "validationerror.uom-mismatch": "UOM produk ini tidak cocok",
  "video.invoices": "Faktur",
  "video.invoices.description": "Pelajari tentang cara mencari dan mengunduh Faktur di Brenntag Connect",
  "video.ordering": "Pemesanan dan Penyusunan Ulang",
  "video.ordering.description": "Pelajari tentang cara Memesan dan menyusun ulang di Brenntag Connect",
  "video.orderlist": "Lihat Daftar Pesanan",
  "video.orderlist.description": "Pelajari tentang cara melihat Riwayat Pesanan Anda di Brenntag Connect",
  "video.productsearch": "Pencarian Produk",
  "video.productsearch.description": "Pelajari tentang cara mencari Produk di Brenntag Connect"
} as const
